import React from 'react';
import styles from './Header.module.scss';
import { GlobalHeader } from '@eventbrite/consumer-header.global-header';
import { useAppContext } from '@/components/_shared/context/AppContext';

export const Header: React.FC = () => {
  const { data } = useAppContext();

  return (
    <div className={styles.wrapper} data-testid="header">
      <div className={styles.content}>
        <GlobalHeader
          env={{ serverUrl: data.serverUrl }}
          request={{ path: '/e/' }}
          isHomePage={false}
          disableFetchUser
        />
      </div>
    </div>
  );
};
